/**
 * Neya Systems, LLC disclaims all warranties with regard to this software,
 * including all implied warranties of merchantability and fitness, in no
 * event shall Neya Systems, LLC be liable for any special, indirect or
 * consequential damages or any damages whatsoever resulting from loss of
 * use, data or profits, whether in an action of contract, negligence or
 * other tortious action, arising out of or in connection with the use or
 * performance of this software.
 *
 * "Copyright (c) 2020 Neya Systems, LLC, all rights reserved."
 *
 * This work contains valuable confidential and proprietary information.
 * Disclosure or reproduction without the written authorization of Neya
 * Systems, LLC is prohibited. This unpublished work by Neya Systems, LLC
 * is protected by the laws of the United States and other countries. If
 * publication of the work should occur, the following notice shall apply.
 */

 import { getBackend } from '../../utilities/endpoints'

 const REACT_APP_BACKEND = getBackend()
 
 export async function fetchCheckVisualizeReady(mongoObjectId) {
     let exist_status = false
 
     let transaction = await fetch(
         `${REACT_APP_BACKEND}/api/v1/datasets/${mongoObjectId}/visualize/ready`
     )
         .then((response) => response.json())
         .then((data) => {
             if (data.success) {
                 console.log(
                     `fetchCheckVisualizeReady: Dataset exists for mongo ID ${mongoObjectId}: ${data.exists}`
                 )
                 exist_status = data.exists
             } else {
                 console.log(data)
                 console.log(
                     `fetchCheckVisualizeReady: Failed to check if dataset exists with status code ${data.status}`
                 )
             }
         })
         .catch((error) => {
             console.log(
                 'fetchCheckVisualizeReady: Unexpected error checking if dataset exists',
                 JSON.stringify(error)
             )
         })
 
     return exist_status
 }
 